export const entitlementConstants = {
  Kiosk: {
    System: 'kiosk.system',
    Device: 'kiosk.device',
  },
  PhoneAgent: {
    AiAgent: 'phone.ai-agent',
  },
};
